'use client';

import { MatchesViewWrapper } from '@/features/odds-page/matches-view-wrapper';
import { SportOddsPage } from '@/features/odds-page/sport-odds-page';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

interface LiveSportPageProps {
	params: {
		sport: string;
		locale: string;
	};
}

export default function LiveSportPage({ params }: LiveSportPageProps) {
	const router = useRouter();
	const view = useAppearanceStore(state => state.view);
	useEffect(() => {
		if (view === ViewEnum.mars) {
			router.push(`/${params.locale}/sports/${params.sport}/l`);
		}
	}, [params.locale, params.sport, router, view]);
	return (
		<MatchesViewWrapper isThirdParty={false}>
			<SportOddsPage />
		</MatchesViewWrapper>
	);
}